import { useEffect, useState } from 'react';


const useClock = () => {
  const [realTime, setRealTime] = useState(new Date());
  const month = realTime.toLocaleString('US', { month: 'short' });
  const day = realTime.toLocaleString('US', { day: 'numeric' });
  const year = realTime.toLocaleString('US', { year: 'numeric' });
  const time = realTime.toLocaleTimeString('en-US');

  useEffect(() => {
    setInterval(() => setRealTime(new Date()), 1000);
  }, []);

  return { day: day, month: month, year: year, time: time };
};

export default useClock;
